'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';

import { ROUTES } from '@/constants/routes';
import { useAuthHydrated } from '@/hooks/use-auth-hydrated';
import { useAuthStore } from '@/store/auth-store';
import { syncSessionCookie } from '@/utils/session-cookie';

const AUTH_PATHS = new Set<string>([
  ROUTES.login,
  ROUTES.register,
  ROUTES.forgotPassword,
]);

/** Keeps middleware routing hints aligned with persisted tokens */
export function SessionCoordinator(): null {
  const hydrated = useAuthHydrated();
  const pathname = usePathname();
  const router = useRouter();
  const refreshToken = useAuthStore((state) => state.refreshToken);

  useEffect(() => {
    if (!hydrated) {
      return;
    }
    syncSessionCookie(Boolean(refreshToken));
  }, [hydrated, refreshToken]);

  useEffect(() => {
    if (!hydrated) {
      return;
    }
    if (refreshToken && AUTH_PATHS.has(pathname)) {
      router.replace(ROUTES.dashboard);
    }
  }, [hydrated, pathname, refreshToken, router]);

  return null;
}
